import { GlobalSettingsDataProvider } from '../GlobalSettingsProvider';

const fallback = () => {
  console.error('Incorrect GlobalSettingsDataProvider usage');
  return Promise.reject();
};

const preferencesFallback = {
  hasWriteAccess: fallback,
  setSettings: fallback,
  getSettings: fallback,
  deleteSettings: fallback,
};

const fallbackGlobalSettingsDataProvider: GlobalSettingsDataProvider = {
  ...preferencesFallback,
  getTheme: fallback,
};

export default fallbackGlobalSettingsDataProvider;
